import { ColDef } from 'ag-grid-community';
import { ColumnTooltip } from '../../../../components/TachoTooltip/columnTooltip';
import {
    assignColDefsDefaults,
    COLUMN_WIDTH,
    compareDateFilter,
    dateSortComparator,
    fieldName,
} from '../../../../../core/helpers/aggrid';
import { TachoColumnState } from '../../../../../core/domainModels/displayPreferences/tachoColumnState';
import { LicenseTerm } from '../../../../../core/domainModels/licenseTerms/LicenseTerm';
import { dateToStringFormat } from '../../../../../core/helpers/moment';
import { downloadRendererIcon } from '../../../../components/AgGrid/Renderers/TableRemoveButton/icons';

export const licenseTermsTableDefaultColumnsDefs: ColDef = {
    sortable: true,
    resizable: true,
    tooltipComponent: ColumnTooltip,
    sortingOrder: ['asc', 'desc', null],
};

export const licenseTermsTableColumnsDefinitions = (
    formatMessage: ({ id }: { id: string }) => string,
    defColumnState: Array<TachoColumnState>,
): Array<ColDef> => {
    const columns: Array<ColDef> = [
        {
            colId: fieldName<LicenseTerm>('notes'),
            headerName: formatMessage({ id: 'licenseTermsNotes' }),
            headerTooltip: formatMessage({ id: 'licenseTermsNotes' }),
            field: fieldName<LicenseTerm>('notes'),
            initialWidth: COLUMN_WIDTH.MD,
        },
        {
            colId: fieldName<LicenseTerm>('licenseType'),
            field: fieldName<LicenseTerm>('licenseType'),
            headerName: formatMessage({ id: 'licencesLicenseType' }),
            initialWidth: 130,
            valueFormatter: (params: any) => {
                return params.value ? formatMessage({ id: params.value }) : '-';
            },
            filterValueGetter: params => {
                return params.data.type ? formatMessage({ id: params.data.licenseType }) : '-';
            },
        },
        {
            colId: fieldName<LicenseTerm>('startDate'),
            headerName: formatMessage({ id: 'licenseTermsStartDate' }),
            headerTooltip: formatMessage({ id: 'licenseTermsStartDate' }),
            field: fieldName<LicenseTerm>('startDate'),
            initialWidth: COLUMN_WIDTH.LG,
            comparator: dateSortComparator,
            valueFormatter(params) {
                return dateToStringFormat(params.value);
            },
            filterValueGetter(params) {
                return dateToStringFormat(params.data.startDate);
            },
            filterParams: {
                comparator: compareDateFilter,
            },
        },
        {
            colId: fieldName<LicenseTerm>('endDate'),
            headerName: formatMessage({ id: 'licenseTermsEndDate' }),
            headerTooltip: formatMessage({ id: 'licenseTermsEndDate' }),
            field: fieldName<LicenseTerm>('endDate'),
            initialWidth: COLUMN_WIDTH.LG,
            comparator: dateSortComparator,
            valueFormatter(params) {
                return dateToStringFormat(params.value);
            },
            filterValueGetter(params) {
                return dateToStringFormat(params.data.endDate);
            },
            filterParams: {
                comparator: compareDateFilter,
            },
        },

        {
            colId: fieldName<LicenseTerm>('downloadUrl'),
            headerName: formatMessage({ id: 'versionsDownload' }),
            headerTooltip: formatMessage({ id: 'versionsDownload' }),
            field: fieldName<LicenseTerm>('downloadUrl'),
            maxWidth: COLUMN_WIDTH.SM,
            minWidth: COLUMN_WIDTH.SM,
            cellRenderer: 'tableButtonRenderer',
            cellRendererParams: {
                onClick: (data: LicenseTerm) => {
                    const link = document.createElement('a');
                    link.href = data.downloadUrl;
                    link.click();
                },
                disabled: () => {},
                icon: downloadRendererIcon,
            },
            filter: false,
            sortable: false,
        },
    ];
    assignColDefsDefaults(columns, defColumnState, true);
    return columns;
};
